module.exports = __webpack_public_path__ + "media/images/illustration_3-3b5627441ba1ed8b8f7a4e373c0fab75.png";